// extracted by mini-css-extract-plugin
export default {"container":"OI-z","error":"PI-z","disabled":"QI-z","submit":"RI-z","option":"SI-z","success":"TI-z","failure":"UI-z"};